<template>
  <div class="content widfix">
    <e-breadcrumbs />

    <div id="layerPop">
      <win-layer-pop>
        <component
          v-if="customComponent"
          :is="customComponent"
          @close="closePoup"
          @agreement="agreementPop"
          :parent-info="popupParams"
        />
      </win-layer-pop>
    </div>
    <form
      id="frm"
    >
      <span>
        <h1 class="page_title">FMC
          <span class="position_relative mr20">
            <button type="button" class="tbl_icon help" @click="showHelp = !showHelp">help</button>
            <div v-show="showHelp" class="tooltip_wrap short position_absolute" style="width:550px; left:0; top:24px;">
              <div class="cont">
                <button type="button" class="close" @click="showHelp = false">close</button>
                <ul class="bul_list_sm" style="list-style: none; list-style-type: none;">
                  <li>
                    {{ $t('fmc_guide.001') }}
                    <br />
                    &nbsp;&nbsp;{{ $t('fmc_guide.002') }} <a href="https://www2.fmc.gov/oti/NVOCC.aspx" target="_blank" class="button sm"> OTI(NVOCC) </a> {{ $t('fmc_guide.002_1') }}
                    <br />
                    {{ $t('fmc_guide.003') }}
                    <br />
                    {{ $t('fmc_guide.004') }}
                    <br />
                    {{ $t('fmc_guide.005') }}
                    <br />
                    &nbsp;&nbsp;{{ $t('fmc_guide.006') }}
                    <br />
                    &nbsp;&nbsp;{{ $t('fmc_guide.007') }}
                    <br />
                    &nbsp;&nbsp;{{ $t('fmc_guide.008') }}
                    <br />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('fmc_guide.009') }}
                    <br />
                    <br v-if="auth.serviceLang ==='JPN' || auth.serviceLang ==='CHN'" />
                    {{ $t('fmc_guide.010') }}
                    <br />
                  </li>
                </ul>
              </div>
            </div>
          </span>
        </h1>
      </span>

      <div class="content_box mt10">
        <div class="content-box">
          <table class="tbl_row border-none">
            <colgroup>
              <col width="100px"><col width="160px">
            </colgroup>
            <tbody>
              <tr>
                <th>Org No.</th>
                <td>
                  <e-input-number
                    v-model="params.fmcOrgNo"
                    id="fmcOrgNo"
                    maxlength="6"
                    :is-phone="true"
                  ></e-input-number>
                </td>
                <td class="border-none">
                  <a class="button blue sh" href="#" @click.prevent="searchFmcInfo()">{{ $t('btn.CMBTK011') }}<!-- 조회 --></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- content_box -->
        <div class="content-box">
          <table class="tbl_row mt10 border-none">
            <colgroup>
              <col width="100px"><col width="160px">
              <col width="160px"><col width="160px">
              <col width="150px"><col width="160px">
            </colgroup>
            <tbody>
              <tr>
                <th>Org. ENM</th>
                <td class="">
                  <input type="text" id="fmcOrgEnm"
                         v-model="params.fmcOrgEnm"
                         oninput="javascript: this.value = this.value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '' );"
                         disabled
                  >
                </td>
                <th class="text-center">Renewal Date</th>
                <td class="">
                  <span class="">
                    <e-date-picker
                      id="fmcRwlDt"
                      v-model="params.fmcRwlDt"
                      :disabled="true"
                      :fmc="'Y'"
                    />
                    <!-- <input type="text" id="fmcRwlDt"
                           v-model="params.fmcRwlDt"
                           disabled
                    > -->
                  </span>
                </td>
                <th class="text-center">License No</th>
                <td class="">
                  <e-input-number
                    v-model="params.fmcLicNo"
                    id="fmcLicNo"
                    maxlength="6"
                    :is-phone="true"
                    :disabled="true"
                  ></e-input-number>
                </td>
                <td class="border-none">
                  <a class="button blue sh" href="#" @click.prevent="memberUpdate()">{{ $t('msg.MYIN010G010.005') }}<!-- 저장 --></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div><!-- content_box // -->

      <div class="content_box mt10">
        <div class="flex_box">
          <span class="input_box">
            <select class="wid200" v-model="fmcSts" @change="checkSelectFmcSts()">
              <option value="">{{ $t('msg.ONEX010T010.004') }}</option>
              <option v-for="fmcInfo in fmcStsInfo" :key="fmcInfo.ctrCd" :value="fmcInfo.cd">{{ fmcInfo.nm }}</option>
            </select>
          </span>
        </div>
        <div id="fmc-realgrid" style="width: 100%; height: 450px"></div>
      </div>
    </form>
  </div>
</template>

<script>
import { createGrid } from '@/plugins/realgridUtil' // realgrid Component
import member from '@/api/rest/user/member'
import ESearchAddress from '@/components/common/ESearchAddress'
import WinLayerPop from '@/pages/trans/popup/WinLayerPop'
import MyInfoPasswordPop from '@/pages/user/popup/MyInfoPasswordPop'
import MyInfoPersonalAgreePop from '@/pages/user/popup/MyInfoPersonalAgreePop'
import MyInfoPersonalAgreeChoicePop from '@/pages/user/popup/MyInfoPersonalAgreeChoicePop'
import MyInfoMarketingAgree from '@/pages/user/popup/MyInfoMarketingAgree'
import DownloadPop from '@/pages/trans/popup/SpecialRfDgDownloadPop'
import DEXT5Upload from '@/components/DEXT5Upload'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import api from '@/api/services/auth'
import EDatePicker from '@/components/common/EDatePickerCustom'
import EInputNumber from '@/components/common/EInputNumber'
import JSZip from 'jszip' // 엑셀 다운로드용 JSZip Component
import { rootComputed, rootMethods } from '@/store/helpers'

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'seq', dataType: 'text' },
  { fieldName: 'fmcOrgNo', dataType: 'text' },
  { fieldName: 'fmcLicNo', dataType: 'text' },
  { fieldName: 'fmcRwlDt', dataType: 'datetime', datetimeFormat: 'yyyyMMdd' },
  { fieldName: 'fmcOrgEnm', dataType: 'text' },
  { fieldName: 'fmcStsCd', dataType: 'text' }
]

export const columns = [
  { name: 'seq', fieldName: 'seq', type: 'text', header: 'No.', editable: false, width: 20 },
  { name: 'fmcRwlDt', fieldName: 'fmcRwlDt', type: 'text', header: 'Renewal Date', editable: false, datetimeFormat: 'yyyy.MM.dd', width: 80 },
  { name: 'fmcOrgNo', fieldName: 'fmcOrgNo', type: 'text', header: 'Organization No', editable: false, width: 80 },
  { name: 'fmcOrgEnm', fieldName: 'fmcOrgEnm', type: 'text', header: 'Organization Name', footer: { numberFormat: '#,##0.00', expression: 'sum' }, editable: false, width: 80 },
  { name: 'fmcLicNo', fieldName: 'fmcLicNo', type: 'text', header: 'License No', editable: false, width: 80 },
  {
 name: 'fmcStsCd',
    fieldName: 'fmcStsCd',
    type: 'text',
    header: 'Status',
    editable: false,
    width: 80,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const idx = cell.index.dataRow
        const fmcStsCd = grid.getValue(idx, 'fmcStsCd')
        const html = []

        let fmcStsNm

        // fmc 정보 승인 상태
        if (fmcStsCd === '01') {
          html.push(`<span class="label2 blue">${app.$t('msg.CMBA100.00200')}</span>`) // 요청
        } else if (fmcStsCd === '02') {
          html.push(`<span class="label2 green">${app.$t('msg.CMBA100.00199')}</span>`) // 승인
        } else {
          html.push(`<span class="label2 red">${app.$t('msg.CMBA380.038')}</span>`) // 거절
        }

        return html
      }
    }
  }

]

const gridLayout = [
  'seq',
  'fmcRwlDt',
  'fmcOrgNo',
  'fmcOrgEnm',
  'fmcLicNo',
  'fmcStsCd'
]

export default ({
  name: 'MyFmcInfo',
  components: {
    WinLayerPop,
    ESearchAddress,
    MyInfoPasswordPop,
    MyInfoPersonalAgreePop,
    MyInfoPersonalAgreeChoicePop,
    MyInfoMarketingAgree,
    DownloadPop,
    DEXT5Upload,
    EBreadcrumbs,
    MyInfoDextUploader: () => import('@/pages/user/MyInfoDextUploader'),
    EDatePicker,
    EInputNumber
  },
  data () {
    return {
      uploadParam: [],
      selectFunc: null,
      showHelp: false,
      ctrList: [],
      userInfoList: [],

      popupParams: '',

      params:
        {
          fmcLicNo: '',
          fmcOrgEnm: '',
          fmcOrgNo: '',
          fmcRwlDt: ''
        },

        fileList: [],
        // 카테고리가 있는 경우
        catList: [],
        fileOriginalName: '',
        mdtyPsnlInfCltnCnst: '',
        choPsnlInfCltnCnst: '',
        recvCnst: '',

        customComponent: null,
        uploadParams: [],
        uploadFileInfo: [],
        dext5Idx: 0,
        isShowDext5: true,
        isShowDext5Pop: false,

        // 다국어 항목 변수
        isKor: true,

        // 영문입력 체크 변수
        valid: '',
        fmcStsNm: '',
        fmApprInfo: {},
        rstList: [],
        gridList: [],
        currentPage: '',
        totalPage: '',
        total: '',

        fmcSts: '',
        fmcStsInfo: [
          { cd: '01', nm: app.$t('msg.CMBA100.00200') },
          { cd: '02', nm: app.$t('msg.CMBA100.00199') },
          { cd: '03', nm: app.$t('msg.CMBA380.038') }
        ],
        fmcRwlDtYn: false
    }
  },
  computed: {
    ...rootComputed
  },
  async mounted () {
    console.log('mounted!')

    window.vmAppFmc = this

    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    const grid = createGrid('fmc-realgrid', {
      fields,
      columns,
      layout: gridLayout,
      // 그리고 헤더 높이 조정
      header: {
        heights: [40]
      },
      displayOptions: {
        rowHeight: 34,
        fitStyle: 'evenFill',
        selectionStyle: 'block'
      },
      stateBar: {
        visible: false
      },
      rowIndicator: {
        visible: false
      },
      checkBar: {
        visible: false
      }
    })
    gridView = grid.gridView
    provider = grid.provider
  },
  created () {
    this.initInfo()

    // 다국어 항목 제어
    if (this.$i18n.locale !== 'ko-KR') {
      this.isKor = false
    }

    console.log('this.loginInfo ::: === ', this.loginInfo)
  },
  methods: {
    ...rootMethods,
        //초기화
    searchInit () {
      this.rstList = []
      provider.setRows(this.rstList)
      this.totalCount = 0
    },
    initInfo () {
        let cstNo = this.auth.cstCd || this.memberDetail.cstCd
        this.rstList = []

        // 직원일때, 정보 조회 안함
        if (this.memberDetail.staffFlag !== 'Y') {
          member.getMemberFmcInfo(cstNo).then(response => {
            const resp = response.data.fmcInfoAll
            console.log('memberinfo resp ::: ', resp)

            this.rstList = this.$_.sortBy(resp, item => parseInt(item.seq, 10))

            provider.setRows(this.rstList)
            this.totalCount = this.rstList.length
            gridView.setAllCheck(false)

            if (this.totalCount === 0) {
              this.openAlert(this.$t('msg.SETT010T010.129')) // '검색된 데이터가 없습니다.')
            }
          })
        }
    },
    closeFun () {
      this.$Simplert.close()
    },
    openAlert (msg) {
      let obj = {
        alertType: 'simple',
        onClose: this.closeFun,
        customCloseBtnClass: 'button blue lg simplert-test1',
        customCloseBtnText: this.$t('msg.MYIN010G010.007'),
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'

      }
      this.$ekmtcCommon.alert(obj)
    },
    async memberQuit () {
      const params = this.params

      params.userId = this.auth.userId

      // 회원탈퇴
      await member.memberQuit(params)
        .then(response => {
          if (response.status === 200) {
            // 회원탈퇴 후 자동 로그아웃
            this.logout()
          } else {
            console.log(response.status)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    async memberUpdate () {
      const isOk = this.checkValidationAll()

      let cstCd = this.auth.cstCd || this.memberDetail.cstCd
      this.params.cstCd = cstCd

      if (isOk) {
        await member.memberFmcInfoUpdate(this.params)
                .then(response => {
            if (response.data === 1) {
              this.openAlert(this.$t('tem.CMAT013')) // 저장되었습니다.
              this.initInfo()
            } else {
              console.log(response.status)
            }
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    async searchFmcInfo () {
      const isOk = this.$ekmtcCommon.isEmpty(this.params.fmcOrgNo)

      if (!isOk) {
       await member.getFmcCrawlingInfo(this.params.fmcOrgNo)
              .then(response => {
          const resp = response.data
          const fmcCraInfo = resp.fmcCraInfo

          if (!this.$ekmtcCommon.isEmpty(fmcCraInfo)) {
            this.params = fmcCraInfo
          } else {
            this.openAlert(this.$t('msg.MYIN050T010.086')) // 해당하는 번호의 FMC 정보가 없습니다. 재확인 바랍니다.
            this.params.fmcLicNo = ''
            this.params.fmcOrgEnm = ''
            this.params.fmcRwlDt = ''
          }
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        this.openAlert(this.$t('msg.MYIN050T010.087'))
      }
    },
    checkValidationAll () {
      const frm = document.querySelector('#frm')
      let isAllOk = true

      if (!this.fnValidationFmc(frm)) {
        isAllOk = false
      }

      return isAllOk
    },
    localShowErrorTooltip (elem, message, flag) {
          const $elem = $(elem)
          const $parent = $elem.parents('td, div').eq(0)

          let $input = ''
          // let $sParent = ''
          let $sMsgBox = ''
          let $msgBox = $parent.find('.tooltip_essen_box')

          if (flag === 'case_one') {
            $input = $elem.children('div').children('input').eq(0)
            $input.addClass('input_error')
          } else {
            $elem.addClass('input_error')
          }

          if (flag === 'case_two') {
            let $sParent = $parent.parents('td, div').eq(0)
            $sParent.addClass('position_relative')
            let $ctMsgBox = $sParent.find('.tooltip_essen_box')

            $sMsgBox = $sParent.find('.tooltip_essen_box')

            if ($sMsgBox.length === 0) {
             $msgBox = $('<p class=\'tooltip_essen_box\'><span class=\'tooltip_essen\'></span></p> ')
             $msgBox.appendTo($sParent)
            }

            $ctMsgBox.find('.tooltip_essen').eq(0).text(message).show()
          } else {
            $parent.addClass('position_relative')

            if ($msgBox.length === 0) {
              $msgBox = $('<p class=\'tooltip_essen_box\'><span class=\'tooltip_essen\'></span></p> ')
              $msgBox.appendTo($parent)
            }
          }
          $msgBox.find('.tooltip_essen').eq(0).text(message).show()
    },
    localHideErrorTooltip (elem, flag) {
          const $elem = $(elem)
          const $parent = $elem.parents('td, div').eq(0)
          let $input = ''

          if (flag === 'case_one') {
            $input = $elem.children('div').children('input').eq(0)
            $elem.children('div').children('input').eq(0).removeClass('input_error')
          }

          if (flag === 'case_two') {
            $input = $elem.children('div').children('input').eq(0)
            $elem.children('div').children('input').eq(0).removeClass('input_error')

            let $sParent = $parent.parents('td, div').eq(0)
            let $sMsgBox = $sParent.find('.tooltip_essen_box')

            $sParent.find('.tooltip_essen').hide()
          }

          $elem.removeClass('input_error')
          $parent.find('.tooltip_essen').hide()
    },
    fnValidationDate () {
      if (frm === undefined) {
        frm = document.querySelector('#frm')
      }

      let isOk = true
      let msg = ''
      const elem = frm.querySelectorAll('#fmcRwlDt')

      if (this.$ekmtcCommon.isEmpty(this.params.fmcRwlDt)) {
        msg = 'Please input date.' // 날짜를 선택해 주세요.
        isOk = false
      }

      if (!isOk) {
        this.$ekmtcCommon.showErrorTooltip(elem, msg)
      } else {
        this.$ekmtcCommon.hideErrorTooltip(elem)
      }

      return isOk
    },
    fnValidationFmc () {
      console.log('fnValidationFmc @@@@@')

      if (frm === undefined) {
        frm = document.querySelector('#frm')
      }

      let isOk = true
      let msg = ''
      let elem
      const elemRwlDt = frm.querySelectorAll('#fmcRwlDt')
      const elemLinsNo = frm.querySelectorAll('#fmcLicNo')
      const elemOrgNo = frm.querySelectorAll('#fmcOrgNo')

      const hasAnyInput =
            !this.$ekmtcCommon.isEmpty(this.params.fmcRwlDt) ||
            !this.$ekmtcCommon.isEmpty(this.params.fmcLicNo) ||
            !this.$ekmtcCommon.isEmpty(this.params.fmcOrgNo)

      if (hasAnyInput) {
        console.log('hasAnyInput @@@@@')

        if (this.$ekmtcCommon.isEmpty(this.params.fmcOrgNo)) {
          msg = 'Please input FMC Organization No.'

          this.$ekmtcCommon.showErrorTooltip(elemOrgNo, msg)
          isOk = false
        } else {
          this.$ekmtcCommon.hideErrorTooltip(elemOrgNo)
        }

        if (this.$ekmtcCommon.isEmpty(this.params.fmcRwlDt)) {
          msg = 'Please input FMC Renewal Date.'

          this.$ekmtcCommon.showErrorTooltip(elemRwlDt, msg)
          isOk = false
        } else {
          this.$ekmtcCommon.hideErrorTooltip(elemRwlDt)
        }
      }

      if (!this.isFutureDate(this.params.fmcRwlDt)) {
        this.openAlert(this.$t('msg.MYIN010G010.061'))
        isOk = false
      }

      if (this.$ekmtcCommon.isEmpty(this.params.fmcOrgNo)) {
        this.openAlert(this.$t('msg.MYIN050T010.087'))
        isOk = false
      }

      return isOk
    },
    //날짜 포맷 변경(추후 공통함수 생성시 변경)
    formattingCreateDate (date) {
      let year = ''
      let month = ''
      let day = ''

      if (!this.$ekmtcCommon.isEmpty(date)) {
        year = date.substr(0, 4)
        month = date.substr(4, 2)
        day = date.substr(6, 2)
      }

      return year + '.' + month + '.' + day
    },
    checkSelectFmcSts () {
      if (this.fmcSts !== '') {
        console.log('this.fmcSts @@@@@@ ', this.fmcSts)

        this.gridList = this.rstList.filter(vo => vo.fmcStsCd === this.fmcSts)

        this.totalCount = this.gridList.length
        gridView.setColumns(columns)
        provider.setRows(this.gridList)
      } else {
        this.totalCount = this.rstList.length
        provider.setRows(this.rstList)
      }
    },
    isFutureDate (yyyymmdd) {
      const today = new Date()
      const todayStr = today.toISOString().slice(0, 10).replace(/-/g, '')

      return Number(yyyymmdd) >= Number(todayStr)
    }
  }
})
</script>
<style scoped>
.popup_dim .layer_close {z-index: 2998 !important}
.popup_dim2 {z-index: 2999 !important}

.border-none {
  border : 0 !important;
}

table th, td {
    border : 0 !important;
    background: white;
}

table th, td {
    padding: 8px 0 0 10px !important;
    border : 0 !important;
    background: white;
}

.bul_list_sm li::before {
  content: none !important;
}

.input_calendar.mid, .input_calendar.mid input {
    width: 160px !important;
}

.tbl_icon.help {
    margin-bottom: 10px !important;
}

</style>
